module.exports = __webpack_public_path__ + "assets/img/folder.d5582fe8.svg";